import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'

@Component({
  selector: 'lin-form-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LabelComponent {
  currency: string

  @Input() currencyLabel: boolean
  @Input()
  get required() {
    return this._required
  }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value)
  }
  private _required: boolean

  constructor(private readonly platformSettingsService: PlatformSettingsService) {
    this.currency = platformSettingsService.getClientCurrency().code || 'AUD'
  }
}
